export const LOG_OUT = 'LOG_OUT';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const SET_USER_STATUS = 'SET_USER_STATUS';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
